module.exports = __webpack_public_path__ + "b5f3409e4fe0fe26691cc0231ddd4a8e.png";